export default "__VITE_ASSET__d08585ff__"